import React from "react";
import "../../Components/404NotFound.css";

const UnauthorizedAccess = () => {
  return (
    <div className="notfound-container">
      <img
        src="/img/majesteye-icon-skeye-form-horizontal-white-background.svg"
        alt="SkeyeForm Logo"
      />
      <div className="notfound-image">403</div>
      <h1 className="notfound-title">Unauthorized Access</h1>
      <p className="notfound-message">
        You don't have permission to access this form. Please contact your
        administrator if you believe this is an error.
      </p>
    </div>
  );
};

export default UnauthorizedAccess;
